export const externalUrls = {
    scanner: 'https://coinmarketman.com/scanner/',
    terms: 'https://coinmarketman.com/terms-of-service/',
    privacy: 'https://coinmarketman.com/privacy-policy/',
    security: 'https://coinmarketman.com/security/',
    blog: 'https://coinmarketman.com/blog/',
    about: 'https://coinmarketman.com/about/',
    roadmap: 'https://coinmarketman.com/roadmap/',
    contactus: 'https://coinmarketman.com/contact-us/',
    pricing: 'https://coinmarketman.com/pricing/',
    unlocked: 'https://coinmarketman.com/unlocked/',
    registration: 'https://coinmarketman.com/registration/',
    verification: 'https://coinmarketman.com/features/verification/',
    resetPassword: 'https://coinmarketman.com/reset-password/',
    docs: 'https://docs.coinmarketman.com/',
    hypertrackerDashboard: 'https://docs.coinmarketman.com/hypertracker-dashboard',
    docsPositions: 'https://docs.coinmarketman.com/rest-api/positions-and-market-exposure',
    docsWalletMetrics: 'https://docs.coinmarketman.com/rest-api/trader-and-wallet-data',
    docsCohorts: 'https://docs.coinmarketman.com/rest-api/segments-and-cohorts',
    docsBuilderAnalytics: 'https://docs.coinmarketman.com/rest-api/builder-and-referral-analytics',
    docsMarketHistory: 'https://docs.coinmarketman.com/rest-api/order-data',
    websoketDoc: 'https://docs.coinmarketman.com/real-time-websocket-streams#quick-start',
    hyperliquidSignUp: 'https://app.hyperliquid.xyz/join/COINMARKETMAN',
    xProfile: 'https://x.com/',
};
